// extracted by mini-css-extract-plugin
module.exports = {"nav-panel":"ls","navPanel":"ls","nav-panel-bg":"lt","navPanelBg":"lt","nav-panel-content":"lu","navPanelContent":"lu","none":"lv","block":"lw"};